import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';

import Icon from '@/components/Base/Icon';
import { CARET_DOWN, CARET_UP } from '@/constants';

import {
  ActionsItemText,
  ActionsItemTitle,
  ActionsItemWrapper,
} from './ActionsItem.styles';

function ActionsItem({ title, description }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleChangeIsOpen = () => setIsOpen((prev) => !prev);

  return (
    <ActionsItemWrapper onClick={handleChangeIsOpen}>
      <ActionsItemTitle>
        {title}

        <Icon
          width={14}
          direction={isOpen ? CARET_UP : CARET_DOWN}
          name="arrow"
        />
      </ActionsItemTitle>

      {!!isOpen && <ActionsItemText>{description}</ActionsItemText>}
    </ActionsItemWrapper>
  );
}

ActionsItem.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default memo(ActionsItem);
